(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/play/play.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/play/play.js');
"use strict";


const {
  createContext,
  useEffect
} = React;
const PlayContext = createContext();
setGlobal('svs.eInstant.play.PlayContext', PlayContext);
const PlayProvider = _ref => {
  let {
    children,
    ticketInfo,
    isDemo
  } = _ref;
  return React.createElement(PlayContext.Provider, {
    value: {
      gameConfigs: svs.eInstant.data.gameConfigs,
      wager: svs.eInstant.data.wager,
      ticketInfo,
      isDemo
    }
  }, children);
};
const Play = _ref2 => {
  let {
    match
  } = _ref2;
  const GameLauncherLEIA = svs.eInstant.play.leia.GameLauncher;
  const GameLauncherIWG = svs.eInstant.play.iwg.GameLauncher;
  const {
    gameUrl
  } = match.params;
  const {
    getTicketInfoByUrl,
    getTicketInfoByWager
  } = svs.eInstant.play.utils;
  const {
    checkLoggedIn
  } = svs.eInstant.util;
  const {
    LEIA,
    IWG
  } = svs.eInstant.play.utils.GAME_PROVIDERS;
  const isDemo = match.path.includes('provspela');
  const ticketInfo = svs.eInstant.data.wager ? getTicketInfoByWager(svs.eInstant.data.wager) : getTicketInfoByUrl(gameUrl);
  if (!ticketInfo) {
    var _svs$eInstant$data$wa;
    const gameName = (_svs$eInstant$data$wa = svs.eInstant.data.wager) === null || _svs$eInstant$data$wa === void 0 ? void 0 : _svs$eInstant$data$wa.description;
    gameUrl && svs.eInstant.logger.error("failed to start game with gameUrl: ".concat(gameUrl));
    gameName && svs.eInstant.logger.error("failed to start game with gameName: ".concat(gameName));
  }
  const {
    gameProvider
  } = ticketInfo;
  useEffect(() => {
    checkLoggedIn(isDemo);
  }, []);
  return React.createElement(PlayProvider, {
    isDemo: isDemo,
    ticketInfo: ticketInfo
  }, gameProvider === LEIA && React.createElement(GameLauncherLEIA, null), gameProvider === IWG && React.createElement(GameLauncherIWG, null));
};
setGlobal('svs.eInstant.play.Play', Play);

 })(window);